/**
 * "Back to site" link pinned to the top-left of the auth screens.
 *
 * The auth screens live in core/ and can't be edited from the game, so the
 * link is mounted beside them by main.ts. The landing is a separate static
 * page served at `/`, not an SPA route — `target="_self"` keeps the SPA's
 * link interceptor from swallowing the click, so the browser does a real load.
 */
export function mountBackToLanding(host: HTMLElement): () => void {
  const link = document.createElement('a');
  link.href = '/';
  link.target = '_self';
  link.setAttribute('aria-label', 'Back to the site');
  link.className = [
    'fixed z-50 inline-flex items-center gap-2 min-h-11 min-w-11 px-3.5',
    'top-[max(0.75rem,env(safe-area-inset-top))] left-[max(0.75rem,env(safe-area-inset-left))]',
    'rounded border border-border bg-surface-2/80 backdrop-blur-sm',
    'font-heading text-sm tracking-wide text-text-dim no-underline',
    'transition-colors duration-150 hover:text-gold hover:border-gold focus-visible:text-gold focus-visible:border-gold',
  ].join(' ');
  link.innerHTML = `
    <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M10 3 5 8l5 5"/>
    </svg>
    <span>Back</span>`;
  host.appendChild(link);
  return () => link.remove();
}
